import { render, staticRenderFns } from "./discover.vue?vue&type=template&id=41145fba&scoped=true"
import script from "./discover.vue?vue&type=script&lang=ts"
export * from "./discover.vue?vue&type=script&lang=ts"
import style0 from "./discover.vue?vue&type=style&index=0&id=41145fba&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41145fba",
  null
  
)

export default component.exports